require('angular')
angular
.module('angularAvant', [])
.controller('TokenAuthorizeController', ['$scope', ($scope) ->
  $scope.onDateChange = (date) ->
    if !$scope[date] || !$scope[date].match(/^\d+$/)
      $scope.TokenForm[date].$setValidity('custom', false)
    else
      $scope.TokenForm[date].$setValidity('custom', true)

])

